<template>
    <div class="input-group">
      <input @keyup.enter="handleQuery($event)" type="text" value="" class="form-control" v-model="query" :placeholder="placeholder">
      <a href="" @click.prevent="handleQuery($event)" class="input-group-addon"><i :class="iconClass"></i></a>
    </div>
</template>
<<script>
export default {
  name: 'p-search',
  props: {
    placeholder: {
      type: String,
      default: 'Pesquisar ...'
    },
    clearInput: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      query: '',
      queried: false
    }
  },
  computed: {
    iconClass: function () {
      return {
        'fa fa-search': !this.queried,
        'fa fa-close': this.queried
      }
    }
  },
  methods: {
    handleQuery (event) {
      if (this.queried === true) {
        if (event.type !== 'keyup') {
          this.query = ''
          this.queried = false
        }
        this.$emit('on-search', this.query)
      } else {
        this.$emit('on-search', this.query)
        this.queried = true
      }
      if (this.clearInput) {
        this.query = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/Search.vue